import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import {GetNavigationHeaderResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/navigation/service.types';
import React from 'react';
import {CategorySlider as CategorySliderFeature} from '../../../features/CategorySlider/CategorySlider';
import {CategorySliderLoading} from '../../../features/CategorySlider/CategorySliderLoading';
import {useCategoryId} from '../utils';
import {useCategorySliderData} from './helpers';

export const CategorySlider: React.FC<PriorityConfig> = ({
  renderingPriority,
}) => {
  return (
    <DataFetcher
      request={useCategorySliderData()}
      Error={null}
      Loading={CategorySliderLoading}
      View={CategorySliderView}
      renderingPriority={renderingPriority}
    />
  );
};

const CategorySliderView: React.FC<GetNavigationHeaderResponse> = props => {
  const activeCategoryId = useCategoryId();

  return (
    <CategorySliderFeature activeCategoryId={activeCategoryId} {...props} />
  );
};
